import CampaignsPartial from "../../partials/campaign/campaigns.partial";

export default function CampaignsScreen() {
  return <CampaignsPartial />;
}
